<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      list: null,
      downloadModalOpen: false,
      downloadModalItem: null,
      downloadModalLoading: false,
      downloadModalError: "",
      downloadModalDone: false,
    };
  },
  methods: {
    load() {
      this.list = null;
      api.get("ebooks/my").then((response) => {
        if (response.data.status === "success") {
          this.list = response.data.list || [];
        } else {
          this.list = [];
        }
      }).catch(() => {
        this.list = [];
      });
    },
    isRowDownloadBusy(row) {
      return (
        this.downloadModalOpen &&
        this.downloadModalLoading &&
        this.downloadModalItem &&
        this.downloadModalItem.id === row.id
      );
    },
    openDownloadModal(row) {
      this.downloadModalItem = row;
      this.downloadModalError = "";
      this.downloadModalDone = false;
      this.downloadModalOpen = true;
      this.downloadModalLoading = true;
      const format = "pdf";
      const q = "?format=" + encodeURIComponent(format);
      api
        .get("ebooks/" + encodeURIComponent(row.id) + "/download" + q)
        .then((response) => {
          this.downloadModalLoading = false;
          if (response.data.status === "success" && response.data.url) {
            this.downloadModalDone = true;
            window.open(response.data.url, "_blank");
          } else {
            this.downloadModalError =
              (response.data && response.data.message) || "Erro ao gerar link.";
          }
        })
        .catch(() => {
          this.downloadModalLoading = false;
          this.downloadModalError = "Erro ao baixar.";
        });
    },
    onDownloadModalHidden() {
      this.downloadModalItem = null;
      this.downloadModalLoading = false;
      this.downloadModalError = "";
      this.downloadModalDone = false;
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">E-books</li>
      <li class="breadcrumb-item">Minha Biblioteca</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <h3>Minha Biblioteca</h3>
    </div>

    <div v-if="list === null" class="card">
      <div class="card-body text-center min-vh-25 d-flex align-items-center justify-content-center">
        <b-spinner></b-spinner>
      </div>
    </div>

    <div v-else-if="list.length === 0" class="card">
      <div class="card-body text-center">Você ainda não comprou e-books.</div>
    </div>

    <div v-else class="table-responsive card library-ebooks-card">
      <table class="table table-hover mb-0 library-table">
        <thead>
          <tr>
            <th>Título</th>
            <th>Comprado em</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>
              <div class="library-title-cell">
                <img
                  v-if="row.cover_url"
                  :src="row.cover_url"
                  :alt="'Capa de ' + row.title"
                  class="thumb"
                />
                <span class="library-title-text">{{ row.title }}</span>
              </div>
            </td>
            <td class="text-muted small align-middle">{{ row.purchased_at }}</td>
            <td class="text-right align-middle">
              <button
                type="button"
                class="btn btn-sm btn-primary library-btn-download d-inline-flex align-items-center text-uppercase"
                :disabled="isRowDownloadBusy(row)"
                :aria-busy="isRowDownloadBusy(row) ? 'true' : 'false'"
                aria-label="Baixar e-book em PDF"
                @click="openDownloadModal(row)"
              >
                <svg
                  class="library-icon-download mr-1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M12 16l4-5h-3V4h-2v7H8l4 5zm-8 4v-2h16v2H4z" />
                </svg>
                Baixar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal
      v-model="downloadModalOpen"
      title="Download"
      centered
      hide-footer
      :no-close-on-backdrop="downloadModalLoading"
      :no-close-on-esc="downloadModalLoading"
      :hide-header-close="downloadModalLoading"
      @hidden="onDownloadModalHidden"
    >
      <p v-if="downloadModalItem" class="text-muted mb-3">
        {{ downloadModalItem.title }}
      </p>
      <div v-if="downloadModalLoading" class="text-center py-4">
        <b-spinner variant="primary" class="mb-3" label="Carregando"></b-spinner>
        <p class="mb-0 text-muted">Preparando o arquivo para download…</p>
      </div>
      <div v-else-if="downloadModalError" class="py-2">
        <p class="text-danger mb-3" role="alert">{{ downloadModalError }}</p>
      </div>
      <div v-else-if="downloadModalDone" class="py-2 text-center">
        <p class="mb-3 text-muted">
          O download deve abrir em uma nova aba. Se nada aparecer, verifique se o navegador bloqueou pop-ups.
        </p>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.library-ebooks-card {
  border: 1px solid rgba(0, 0, 0, 0.125);
  box-shadow: none;
}

.library-table th {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-top: none;
}

.library-th-action {
  min-width: 110px;
}

.library-title-cell {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 44px;
}

.library-title-text {
  font-weight: 500;
  color: #1a1512;
  line-height: 1.35;
}

.thumb {
  width: 80px;
  flex-shrink: 0;
  object-fit: cover;
  vertical-align: middle;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(26, 21, 18, 0.08);
}

.library-btn-download {
  min-height: 36px;
  touch-action: manipulation;
}

.library-icon-download {
  flex-shrink: 0;
}
</style>
